
import React from 'react';
import { sprintf } from 'sprintf-js';

class DivGrid extends React.Component {

  /**
   * this.props.row_style = { ... } Row div style overrides
   *
   * this.props.container_div = { ... } Container div style overrides
   *
   * this.props.items [
   *   [ item, item, item, ... ]
   *   ...
   * ]
   *
   * item: {
   *   width: float
   *   elem: <JSX>
   *   div_style: {}  // optional
   * }
   *
   * Widths are all added up, divs are given proportional widths
   */

  dumpRow = (row, index, array) => {
    const row_style = {
      width: "100%",
      ...this.props.row_style,
    };
    if (index === array.length - 1) {
      delete row_style.marginBottom;
    }

    let total_width = 0;
    row.forEach(item => {
      total_width += item.width;
    });
    const widths = row.map(item => {
      return sprintf("%f%%", item.width / total_width * 100);
    });
    return (
      <div style={row_style} key={index}>
        { row.map((item, index) => {

          const div_style = {
            width: widths[index],
            display: "inline-block",
            verticalAlign: "top",
            ...item.div_style,
          };

          return (
            <div style={div_style} key={index}>
              { item.elem }
            </div>
          );
        })}
      </div>
    )
  }

  render = () => {

    const container_div = {
      width: "100%",
      ...this.props.container_div
    };
    const items = this.props.items;

    return (
      <div style={container_div}>
        { items.map(this.dumpRow) }
      </div>
    )
  }

}

export { DivGrid };
